export default {
    ADD_NODE: 'ADD_NODE',
    ADD_EDGE: 'ADD_EDGE',
    UPDATE_NODE: 'UPDATE_NODE',
    UPDATE_EDGE: 'UPDATE_EDGE',
    UPDATE_DATA: 'UPDATE_DATA',
    DEL_NODE: 'DEL_NODE',
    DEL_EDGE: 'DEL_EDGE',
    SET_POS: 'SET_POS',
    SET_DIM: 'SET_DIM',
    SET_BENDW: 'SET_BENDW',
};
